const getDistanceKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Earth radius in km

  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
      Math.cos((lat2 * Math.PI) / 180) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // distance in km
};

export const getNearestStores = (user, stores, limit = 10) => {
  const nearest = stores
    .map((store) => {
      const distance = getDistanceKm(user.lat, user.lng, store.lat, store.lng);

      return {
        ...store,
        distance,
      };
    })
    .sort((a, b) => a.distance - b.distance)
    .slice(0, limit);

  // biggest distance among nearest stores
  const maxDistance =
    nearest.length > 0 ? Math.max(...nearest.map((s) => s.distance)) : 0;

  return {
    stores: nearest,
    maxDistance,
  };
};

export const getZoomLevel = (distanceKm) => {
  if (distanceKm < 1) return 13;
  if (distanceKm < 5) return 11;
  if (distanceKm < 10) return 10;
  if (distanceKm < 25) return 9;
  if (distanceKm < 50) return 8;
  return 6;
};
